import React, { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { 
  Box,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import axios from 'axios'

const Navigation = () => {
  const theme = useTheme()
  const location = useLocation()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileOpen, setMobileOpen] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    axios.get('/api/v1/auth/me', { withCredentials: true })
      .then(res => setIsAdmin(!!res.data.is_admin))
      .catch(() => setIsAdmin(false))
  }, [])

  const allNavItems = [
    { label: 'Certificate Onboard', path: '/' },
    { label: 'Bulk Upload', path: '/bulk-upload' },
    { label: 'Certificates', path: '/aws-certificates' },
    { label: 'CRQs', path: '/crqs' },
    { label: 'Onboarding ITSM Products', path: '/product-dl' },
    { label: 'Products Info', path: '/onboarded-products' },
    { label: 'Admin', path: '/admin', adminOnly: true },
  ]

  const navItems = allNavItems.filter(item => !item.adminOnly || isAdmin)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const drawer = (
    <Box sx={{ width: 280, pt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, pb: 1 }}>
        <IconButton onClick={handleDrawerToggle}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={item.disabled ? 'div' : NavLink}
              to={item.disabled ? undefined : item.path}
              onClick={item.disabled ? undefined : handleDrawerToggle}
              disabled={item.disabled}
              sx={{
                '&.active': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  }
                }
              }}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  )

  if (isMobile) {
    return (
      <>
        <Box 
          sx={{ 
            backgroundColor: 'primary.main',
            py: 1,
            px: 2,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open navigation"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ color: 'white' }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ ml: 2, color: 'white', fontSize: '16px' }}>
            Menu
          </Box>
        </Box>
        <Drawer
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>
      </>
    )
  }

  return (
    <Box 
      sx={{ 
        backgroundColor: 'primary.main',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      <Box className="container mx-auto">
        <Tabs
          value={false}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              color: 'white',
              textTransform: 'none',
              fontSize: '14px',
              minHeight: '44px',
              borderLeft: '1px solid #4b95db',
              '&:first-of-type': {
                borderLeft: 'none',
              },
              '&:hover': {
                backgroundColor: 'white',
                color: 'primary.dark',
              },
              '&.active': {
                backgroundColor: 'white',
                color: 'primary.dark',
              }
            },
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          {navItems.map((item) => {
            const isActive = location.pathname === item.path
            return (
              <Tab
                key={item.path}
                label={item.label}
                component={item.disabled ? 'div' : NavLink}
                to={item.disabled ? undefined : item.path}
                disabled={item.disabled}
                className={isActive ? 'active' : ''}
              />
            )
          })}
        </Tabs>
      </Box>
    </Box>
  )
}

export default Navigation
